import { Button } from "@mui/material";

export const CopyPasteBlockActions = (props: CopyPasteBlockActionsProps) => {
  const { copiedBlocksCount, onCopy, onPaste, onClear, canCopy = true } = props;

  return (
    <div className="layout-copy-paste-block-actions">
      <Button variant="text" color="secondary" onClick={onClear} disabled={!copiedBlocksCount}>
        Clear
      </Button>
      <Button onClick={onPaste} disabled={!copiedBlocksCount}>
        Paste {copiedBlocksCount ? `(${copiedBlocksCount})` : ""}
      </Button>
      <Button onClick={onCopy} disabled={!canCopy}>
        Copy
      </Button>
    </div>
  );
};

interface CopyPasteBlockActionsProps {
  copiedBlocksCount: number;
  canCopy?: boolean;
  onCopy: () => void;
  onPaste: () => void;
  onClear: () => void;
}
